import {
    Box,
    Button,
    Paper,
    Table, TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React from "react";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

function DeckPreviewView({deckTitle, columnTitles, previewWords, confirmationCallback}) {


    return (
        <Box>
            <Typography variant="h4" fontWeight="bold" align="center" sx={{mb: 4}}>{deckTitle}</Typography>
            <Typography variant="body1" sx={{mb: 1}}>Here is a sample of words from this list:</Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {columnTitles.map((title, index) => (
                                    <StyledTableCell key={index}>{title}</StyledTableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {previewWords.map((word, index) => (
                                <StyledTableRow key={index}>
                                    {word.map((wordPart, wordPartIndex) => (
                                        <StyledTableCell key={wordPartIndex}>{wordPart}</StyledTableCell>
                                    ))}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            <Button variant="contained"
                    color="purple"
                    sx={{borderRadius: 3, mb: 3, mt: 3}}
                    onClick={confirmationCallback}
            >
                Continue
            </Button>
        </Box>
    )

}

export default DeckPreviewView;